var __WEBPACK_NAMESPACE_OBJECT__ = require("url-template");;